import { CategoryStructure, useCategories } from "./useCategories";

interface UseCategoriesTreeOptions {
    onlyStandardCategories?: boolean;
}

export function useCategoriesTree(options?: UseCategoriesTreeOptions) {
    return useCategories({
        structure: CategoryStructure.TREE,
        onlyStandardCategories: options?.onlyStandardCategories ?? false,
    });
}
